import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'suffix',
})
export class SuffixPipe implements PipeTransform {
  transform(value: any, ...args: unknown[]): unknown {
    if (value?.suffix && value?.si_filter_access === 'No') {
      return value?.suffix?.translations?.[0].name;
    }

    if (value?.si_filter_access === 'Yes') {
      return value?.si_unit?.si_unit_values?.[0]?.translations?.[0].name;
    }
    if (value?.si_filter_access === 'Currency') {
      return value?.currency;
    }

    return undefined;
  }
}
